import { ApiService } from "../..";

export const getAllSampleStatus = () => {
  return ApiService.baseAction("sample/all_sample_status/", {}, "get");
};
